module.exports = __webpack_public_path__ + "static/media/dz.c4051775.svg";